import { render, staticRenderFns } from "./courseware.vue?vue&type=template&id=01eed051&scoped=true"
import script from "./courseware.vue?vue&type=script&lang=js"
export * from "./courseware.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01eed051",
  null
  
)

export default component.exports